/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Notifications_Message_Body_HighInputs */

const he_notifications_message_body_high = /** @type {(inputs: Notifications_Message_Body_HighInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`מקסימום ${i?.price}`)
};

const en_notifications_message_body_high = /** @type {(inputs: Notifications_Message_Body_HighInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`high ${i?.price}`)
};

/**
* | output |
* | --- |
* | "high {price}" |
*
* @param {Notifications_Message_Body_HighInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_body_high = /** @type {((inputs: Notifications_Message_Body_HighInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Body_HighInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_body_high(inputs)
	return en_notifications_message_body_high(inputs)
});